module.exports = __webpack_public_path__ + "img/prize.0208f579.png";